var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSmallClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.999,
    height: 13.999,
    viewBox: "0 0 13.999 13.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558.001 -2574)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(794.377 2549.547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-229.376,24.453a7.008,7.008,0,0,0-7,7,7.008,7.008,0,0,0,7,7,7.008,7.008,0,0,0,7-7A7.007,7.007,0,0,0-229.376,24.453Zm0,13.041a6.048,6.048,0,0,1-6.041-6.041,6.048,6.048,0,0,1,6.041-6.041,6.048,6.048,0,0,1,6.041,6.041A6.048,6.048,0,0,1-229.376,37.494Z",
    fill: "#3d5567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133.033,72.313h-3.325V68.681a.479.479,0,0,0-.479-.479.479.479,0,0,0-.479.479v4.111a.479.479,0,0,0,.479.479h3.8a.479.479,0,0,0,.479-.479A.479.479,0,0,0-133.033,72.313Z",
    transform: "translate(-92.732 -40.954)",
    fill: "#3d5567"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSmallClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/small-clock.a1bf1953.svg";
export { ForwardRef as ReactComponent };